// Helpers de grapheme para o campo "Indicador" da Sinaleira de Lucratividade.
//
// Um "grapheme" representa o que o usuário enxerga como UM caractere na tela.
// Para letras ASCII (A, B, C) cada caractere é um grapheme. Já um emoji como 🚀
// ocupa 2 code points em JavaScript, e emojis compostos como 👨‍👩‍👧 chegam a
// 5+ code points unidos por ZWJ. Estes helpers garantem que tratamos um emoji
// inteiro como uma unidade só.

export function extrairPrimeiroCaractereVisivel(texto) {
  if (!texto) return ''
  if (typeof Intl !== 'undefined' && Intl.Segmenter) {
    const segmentador = new Intl.Segmenter(undefined, { granularity: 'grapheme' })
    const primeiroSegmento = segmentador.segment(texto)[Symbol.iterator]().next().value
    return primeiroSegmento ? primeiroSegmento.segment : ''
  }
  // Fallback para navegadores sem Intl.Segmenter: itera por code points.
  // Não cobre ZWJ corretamente, mas serve para emojis simples.
  return [...texto][0] || ''
}

export function contarCaracteresVisiveis(texto) {
  if (!texto) return 0
  if (typeof Intl !== 'undefined' && Intl.Segmenter) {
    const segmentador = new Intl.Segmenter(undefined, { granularity: 'grapheme' })
    return [...segmentador.segment(texto)].length
  }
  return [...texto].length
}

export function indicadorTemUmCaractereOuEmoji(texto) {
  return contarCaracteresVisiveis(texto) === 1
}

export function isLetraAlfabetica(caractere) {
  // \p{L} casa qualquer letra Unicode (latina, cirílica, etc.) e exclui
  // dígitos, símbolos e emojis.
  return typeof caractere === 'string' && caractere.length === 1 && /\p{L}/u.test(caractere)
}

// Mantém o valor do indicador limitado a 1 caractere visível. Se for letra,
// converte para maiúscula (padrão do sistema). Se for emoji, preserva como
// digitado. Retorna a string já normalizada.
export function normalizarIndicador(texto) {
  const primeiroCaractere = extrairPrimeiroCaractereVisivel(texto)
  if (!primeiroCaractere) return ''
  return isLetraAlfabetica(primeiroCaractere)
    ? primeiroCaractere.toUpperCase()
    : primeiroCaractere
}
